export function analyzeFileName(fileName, clients, shopSigns) {
  const result = {
    shopSign: null,
    client: null,
    year: null,
    week: null
  };

  // Convert filename to lowercase for easier matching
  const lowerFileName = fileName.toUpperCase();

  // Detect shop sign
  result.shopSign = shopSigns.find(sign => lowerFileName.includes(sign));

  // Detect client
  result.client = clients.find(client => lowerFileName.includes(client));

  // Detect week number (W03, S11, etc.)
  const weekMatch = lowerFileName.match(/[ws](\d{2})/i);
  if (weekMatch) {
    result.week = parseInt(weekMatch[1]);
  } else {
    // Get current week number
    const now = new Date();
    result.week = Math.ceil((now - new Date(now.getFullYear(), 0, 1)) / 604800000);
  }
  // Format week to always be two digits (WW)
  result.week = result.week.toString().padStart(2, '0');

  // Detect year (202X)
  const yearMatch = lowerFileName.match(/20\d{2}/);

  if (yearMatch) {
    result.year = parseInt(yearMatch[0]);
  } else {
    // Get current year
    result.year = new Date().getFullYear();
  }

  return result;
}